import { render, staticRenderFns } from "./yxlCopyright.vue?vue&type=template&id=1476679d&scoped=true&"
import script from "./yxlCopyright.vue?vue&type=script&lang=js&"
export * from "./yxlCopyright.vue?vue&type=script&lang=js&"
import style0 from "./yxlCopyright.vue?vue&type=style&index=0&id=1476679d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1476679d",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/yxlCopyright.vue
// module id = null
// module chunks = 